export default {"src":"https://web.cdn.greenlight.com/2.1355.2/_next/static/media/plus.84daaa89.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};